import moment from 'moment';
import LineChart from '@/components/LineChart.vue';
import getString from '@/helpers/GetStrings';


const colors = {
  blue: '#6CC6E3',
  red: '#E76B66',
  purple: '#AA679D',
  yellow: '#F0D250',
  orange: '#E98B5B',
};

// In this folder, common variables can be accessed and edited in a single place.
export default {
  components: {
    LineChart,
  },
  props: {
    type: {
      type: String,
      default: 'dashboard',
    },
    hasRedirect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataReady: false,
      data: {},
      scaleOptions: {
        xAxes: [{
          gridLines: {
            display: true,
          },
          ticks: {
            fontStyle: 'bold',
            maxRotation: 45,
            minRotation: 0,
            autoSkip: true,
            maxTicksLimit: 20,
          },
        }],
        yAxes: [{
          gridLines: {
            display: true,
          },
          ticks: {
            fontStyle: 'bold',
            beginAtZero: true,
            callback(value) {
              if (Math.floor(value) === value) {
                return value;
              }
              return null;
            },
          },
        }],
      },
    };
  },
  methods: {
    getString,
    handleData() {
      this.data = this.statisticData;
      this.dataReady = true;
    },
    formatCurrency(val) {
      const locale = this.$store.state.stringsStore.language === 'en' ? 'en-EN' : 'nl-NL';
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'EUR',
      }).format(val);
    },
    formatDate(val, format = 'dddd LL') {
      const lang = this.$store.state.stringsStore.language;
      return moment(val).locale(lang).format(format);
    },
    initDataset(color) {
      return {
        label: this.$store.state.stringsStore.strings.orders,
        borderWidth: 2,
        pointBorderColor: color,
        backgroundColor: `${color}33`,
        borderColor: color,
        pointBackgroundColor: color,
        hidden: false,
        data: [],
      };
    },
    toggleData(legendId) {
      this.$refs[this.component].chartData.datasets[legendId].hidden = !this.$refs[this.component].chartData.datasets[
        legendId].hidden;
      this.$refs[this.component].$data._chart.update();
    },
    getColor(name) {
      return colors[name];
    },
    redirect() {
      if (this.hasRedirect) {
        this.$router.push({
          name: 'StatisticsOverview',
        });
      }
    },
  },
  computed: {
    labelDateFormat() {
      return this.$store.getters.groupBy === 'MONTH' ? 'MMM YYYY' : 'dd. D/M';
    },
    isDataLoaded() {
      return this.$store.getters.isDataLoaded(this.component);
    },
    statisticData() {
      return this.$store.getters.statisticByComponent(this.type, this.component);
    },
  },
  mounted() {
    this.handleData();
  },
};
